import { useProductPackage } from '../hooks';

export const calcKarNum = (arr: any[], specKey: string, numKey: string, resKey: string) => {
  if (!arr?.length) return;
  const { convertToLargePackage } = useProductPackage();
  arr.forEach((i) => {
    i[resKey] = convertToLargePackage(i[numKey], 'PCS', 'KAR', i[specKey]);
  });
};
